import * as yup from 'yup'

export const infoProjectValidation = yup.object({
  code: yup.string().required('El código es obligatorio'),
  name: yup.string().required('El nombre es obligatorio'),
  // description: yup.string().required('La descripción es obligatoria'),
  item: yup.string().required('El item es obligatorio'),
  hubId: yup.string().required('El hub es obligatorio'), 
  status: yup.string().required('El estado es obligatorio'),
  startAt: yup.date().required('La fecha de inicio es obligatoria'),
  finishAt: yup
    .date()
    .nullable() 
    .when('status', { 
      is: 'Completado',
      then: yup.date().required('La fecha de finalización es obligatoria cuando el proyecto está en estado "Completado"'),
      otherwise: yup.date().nullable(),
    })
    .test(
      'is-greater',
      'La fecha de finalización no puede ser menor que la fecha de inicio',
      function (value) {
        const { startAt } = this.parent
        return !value || !startAt || value >= startAt
      }
    )
})
